import request from '@/utils/request'

// 网站配置
export const getSystemConfig = params => {
  return request({
    url: '/pc/config',
    params
  })
}
